import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { color } from "src/styles/variables";
import Container from "src/react/layout/container";
import { LinkButton } from "src/react/components/link";
import { ButtonWrapper } from "src/react/forms/styles";

function CallToAction({ homepage, hideHowItWorks }) {
  return (
    <Wrapper>
      <Container>
        <Inner>
          <Heading>Join Cornerstone today</Heading>
          <ButtonWrapper>
            {homepage ? (
              <HomepageLinks />
            ) : (
              <DefaultLinks hideHowItWorks={hideHowItWorks} />
            )}
          </ButtonWrapper>
        </Inner>
      </Container>
    </Wrapper>
  );
}
CallToAction.propTypes = {
  homepage: PropTypes.bool,
  hideHowItWorks: PropTypes.bool,
  variant: PropTypes.string,
};

export default CallToAction;

function HomepageLinks() {
  return (
    <Fragment>
      <LinkButton
        variant="outlineSecondary"
        data-selector="products-button"
        to="/products"
      >
        Shop now
      </LinkButton>
    </Fragment>
  );
}

function DefaultLinks({ hideHowItWorks }) {
  return (
    <Fragment>
      <LinkButton variant="outlineSecondary" to="/products">
        Shop now
      </LinkButton>
      {!hideHowItWorks && (
        <LinkButton variant="outlineSecondary" to="/how-it-works">
          How It Works
        </LinkButton>
      )}
    </Fragment>
  );
}
DefaultLinks.propTypes = {
  hideHowItWorks: PropTypes.bool,
};

const Wrapper = styled.div`
  background: ${color.mineShaft};
  padding: 50px 0;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: ${color.white};
`;

const Heading = styled.h2`
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 24px;
`;
